import React from 'react';

const BrowsePage = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>Browse Memecoins</h2>
      <p>Explore all current and past tokens here.</p>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'VT323',
    color: '#f0f0f0',
  },
  heading: {
    fontSize: '2rem',
    color: '#FAFF00',
    marginBottom: '1rem',
  },
};

export default BrowsePage;